var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "btn-group btn-group-sm",
      attrs: { role: "group", "aria-label": "Styles" },
    },
    [
      _c("div", { staticClass: "dropdown" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-sm dropdown-toggle",
            class: { "btn-light": !_setup.isDarkMode },
            attrs: {
              type: "button",
              id: "stylesDropdown",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false",
            },
          },
          [
            _vm.editor.getAttributes("paragraph").class === "lead"
              ? _c("span", [_vm._v("Lead")])
              : _vm.editor.isActive("code")
              ? _c("span", [_vm._v("Code")])
              : _c("span", [_vm._v("Styles")]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass: "dropdown-menu",
            attrs: { "aria-labelledby": "stylesDropdown" },
          },
          [
            _vm.editor.isActive("link")
              ? [
                  _c("li", { staticClass: "dropdown-header" }, [
                    _vm._v("Button Styles"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_setup.buttonStyles, function (style) {
                    return _c("li", { key: style.class }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "dropdown-item d-flex align-items-center",
                          class: {
                            active:
                              _vm.editor.getAttributes("link").class ===
                              style.class,
                          },
                          on: {
                            click: function ($event) {
                              return _setup.applyClass(style.class)
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              class: [
                                "badge rounded-circle me-2",
                                style.bg.replace("btn", "bg"),
                              ],
                              staticStyle: {
                                width: "10px",
                                height: "10px",
                                padding: "0",
                              },
                            },
                            [_vm._v(" ")]
                          ),
                          _vm._v(" "),
                          _c("small", [_vm._v(_vm._s(style.name) + " button")]),
                        ]
                      ),
                    ])
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("li", { staticClass: "dropdown-header" }, [
              _vm._v("Block styles"),
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  class: {
                    active:
                      _vm.editor.getAttributes("paragraph").class === "lead",
                  },
                  on: {
                    click: function ($event) {
                      return _setup.applyClass("lead")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "bi bi-fonts me-1" }),
                  _vm._v(" "),
                  _c("small", [_vm._v("Lead")]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "dropdown-header" }, [
              _vm._v("Inline styles"),
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "a",
                {
                  staticClass:
                    "dropdown-item d-flex justify-content-between align-items-center",
                  class: { active: _vm.editor.isActive("code") },
                  on: {
                    click: function ($event) {
                      _vm.editor.chain().focus().toggleCode().run()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "bi bi-code me-1" }),
                  _vm._v(" "),
                  _c("small", [_vm._v("Code")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-muted ms-5 small" }, [
                    _vm._v(_vm._s(_setup.modKey) + " E"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _setup.isOdp
              ? [
                  _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        class: {
                          active: _vm.editor.isActive("textStyle", {
                            color: "#e74c3c",
                          }),
                        },
                        style: _vm.editor.isActive("textStyle", {
                          color: "#e74c3c",
                        })
                          ? {}
                          : { color: "#e74c3c" },
                        on: {
                          click: function ($event) {
                            _vm.editor.isActive("textStyle", {
                              color: "#e74c3c",
                            })
                              ? _vm.editor.chain().focus().unsetColor().run()
                              : _vm.editor
                                  .chain()
                                  .focus()
                                  .setColor("#e74c3c")
                                  .run()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "bi bi-palette me-1" }),
                        _vm._v(" "),
                        _c("small", [_vm._v("Red")]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        class: {
                          active: _vm.editor.isActive("textStyle", {
                            color: "#27ae60",
                          }),
                        },
                        style: _vm.editor.isActive("textStyle", {
                          color: "#27ae60",
                        })
                          ? {}
                          : { color: "#27ae60" },
                        on: {
                          click: function ($event) {
                            _vm.editor.isActive("textStyle", {
                              color: "#27ae60",
                            })
                              ? _vm.editor.chain().focus().unsetColor().run()
                              : _vm.editor
                                  .chain()
                                  .focus()
                                  .setColor("#27ae60")
                                  .run()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "bi bi-palette me-1" }),
                        _vm._v(" "),
                        _c("small", [_vm._v("Green")]),
                      ]
                    ),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }